/*
 Created by qing on 2021/7/3
 Des:
 */
import BaseItem from "../BaseItem"
import {
  DATA_TYPE__NUMBER, DATA_TYPE__STRING,
  DEFAULT_VALUE__CUSTOM,
  DEFAULT_VALUE__FORMULA,
  DEFAULT_VALUE__RELATE_DATA,
  DEFAULT_VALUE__RELATE_DATA_NEW, FORM_ITEM__IFRAME,
  FORM_ITEM__TABLE,
  FORM_ITEM__VIDEO
} from "../types"
import {defaultValueInit} from "../utils"

class Iframe extends BaseItem {

  constructor() {
    super()

    this.value = ''

    this.codeInfo = "" //代码
    this.sizeType = "MATCH" //MATCH 适应宽度 FIXED 固定
    this.fixedWidth = ""
    this.realWidth = ""
    this.realHeight = ""

    this.defaultValue = {
      defaultType: DEFAULT_VALUE__CUSTOM,
      customValue: ''
    }
  }

  get title() {
    return this.fieldTitle || Iframe._title
  }

  set title(val) {
    this.fieldTitle = val
    this.temTitle = val
  }
}

Iframe._title = 'iframe'
Iframe.type = FORM_ITEM__IFRAME
Iframe.use = true
Iframe.prototype.icon = 'el-icon-c-scale-to-original'

Iframe.prototype.type = Iframe.type
Iframe.prototype.dataType = DATA_TYPE__STRING
Iframe.prototype.defaultValueList = [
  {
    label: '自定义',
    value: defaultValueInit(DEFAULT_VALUE__CUSTOM, 0)
  },
  {
    label: '公式',
    value: defaultValueInit(DEFAULT_VALUE__FORMULA)
  },
  {
    label: '关联数据',
    value: defaultValueInit(DEFAULT_VALUE__RELATE_DATA)
  },
  {
    label: '关联数据2.0',
    value: defaultValueInit(DEFAULT_VALUE__RELATE_DATA_NEW)
  }
]

Iframe.prototype.filterOpts = [
  {
    name: '为空',
    method: 'empty'
  },
  {
    name: '不为空',
    method: 'not_empty'
  },
]
Iframe.prototype.getValue = function () {
  return this.value
}
Iframe.prototype.setValue = function (val) {
  if (this.parent && this.parent.type === FORM_ITEM__TABLE) {
    return
  }
  this.value = val || ''
}
Iframe.prototype.setConf = function (opts) {
  this.setBase(opts)
  this.codeInfo = opts.codeInfo
  this.sizeType = opts.sizeType
  this.realWidth = opts.realWidth
  this.realHeight = opts.realHeight
  this.fixedWidth = opts.fixedWidth
  if (opts.defaultValue) {
    this.defaultValue = opts.defaultValue
    if (opts.defaultValue.defaultType === DEFAULT_VALUE__CUSTOM) {
      this.value = this.defaultValue.customValue
    }
  }
}
Iframe.prototype.getConf = function () {
  const base = this.getBase()
  return {
    ...base,
    codeInfo: this.codeInfo,
    sizeType: this.sizeType,
    realWidth: this.realWidth,
    realHeight: this.realHeight,
    defaultValue: this.defaultValue,
    fixedWidth: this.fixedWidth
  }
}
Iframe.prototype.valueToString = function (value) {
  value = value || this.value
  return value
}
export default Iframe
